
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from '../config';

export const useUploadExcelMutation = ({ setsnackbarStatus, setUploadProgress }) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ formData }) => {

            return axios.post(
                `${config.API_URL}/table/payrollSheet`,
                formData,
                {
                    withCredentials: true,
                    onUploadProgress: progressEvent => setUploadProgress(Math.round((progressEvent.loaded / progressEvent.total) * 100))
                }

            );
        },
        onSuccess: async (data, variables) => {
            await queryClient.invalidateQueries({ queryKey: ['PaymentListPatients'], refetchType: 'active' }, { cancelRefetch: false });
        },
        onSettled: (data, error, variables, context) => {
            // console.log('data:',data, 'error:', error, 'variables:', variables, 'context:', context);
            if (error) {
                setsnackbarStatus(
                    {
                        open: true,
                        message: `Error Uploading File`,
                        severity: 'error'

                    }
                )

            } else if (data.status === 206) {
                if (data?.data && (data?.data?.missingRecords || data?.data?.processedEntries)) {
                    setsnackbarStatus(
                        {
                            open: true,
                            message: `Processed ${data?.data?.processedEntries} Entries with ${data?.data?.missingRecords} Missing Records`,
                            severity: 'warning',
                            duration: 2500
                        }
                    )
                } else {
                    setsnackbarStatus(
                        {
                            open: true,
                            message: `Some Entries are Missing`,
                            severity: 'warning',
                            duration: 2500

                        }
                    )
                }

            } else if (data.status === 200) {
                if (data?.data && data?.data?.processedEntries) {
                    setsnackbarStatus(
                        {
                            open: true,
                            message: `Processed ${data?.data?.processedEntries} Entries Successfully`,
                            severity: 'success',
                            duration: 2500
                        }
                    );

                } else {
                    setsnackbarStatus(
                    {
                        open: true,
                        message: `File Uploaded Successfully`,
                        severity: 'success',
                        duration: 2500

                    }
                )
                }


            }
        },


    })






}